module.exports = __webpack_public_path__ + "img/nodata.8fd51561.png";